import { Box, Grid } from '@mui/material'
import type { TableBoxProps } from './types'
import type { PropsWithChildren } from 'react'
import { styles } from './styles'

export const TableBox = (props: PropsWithChildren<TableBoxProps>) => {
  const { label, children, isHead = false, spacing = 1.5 } = props
  return (
    <Grid
      p={spacing}
      sx={{ ...(isHead && styles.head) }}
      container
      alignItems={'center'}
    >
      <Grid item sm={5}>
        <Box>{label}</Box>
      </Grid>
      {children && (
        <Grid item sm={7}>
          <Box>{children}</Box>
        </Grid>
      )}
    </Grid>
  )
}
